import { Button, Tooltip } from '@mui/material';
import { connect } from 'react-redux';
import { modalActions } from '../../../Actions';
import { AlertModal } from '../../Modals';
import styles from './ViewPageHeader.module.scss';
import { useAuth } from '@/Components/Auth/Login/auth';
import Breadcrumb from '@/Components/Breadcrumb/Breadcrumb';

const ViewPageHeader = (props) => {
	const {
		heading,
		handleDelete,
		showDelete,
		showEdit,
		showBreadcrumbs,
		toggleAlert,
		breadcrumbs,
		extraActions,
		truncate = false,
	} = props;

	const handleEdit = () => {
		props.handleEdit();
	};
	const { userConfig = {} } = useAuth();
	const { level } = userConfig?.userDetails || {};

	return (
		<div className={`${styles.root}`}>
			{showBreadcrumbs ? (
				<Breadcrumb breadcrumbs={breadcrumbs} truncate={truncate} />
			) : (
				<p className='heading'>
					{truncate && heading?.length > 30 ? (
						<Tooltip title={heading} placement='bottom-start'>
							<span>{`${heading.substring(0, 20)}...`}</span>
						</Tooltip>
					) : (
						heading
					)}
				</p>
			)}
			<div className={`${styles['btn-group']}`}>
				{extraActions && extraActions}
				{showEdit && level !== 1 && (
					<Button
						variant='outlined'
						color='primary'
						onClick={handleEdit}
					>
						Edit
					</Button>
				)}
				{showDelete && level !== 1 && (
					<>
						<Button
							variant='outlined'
							color='secondary'
							onClick={() => {
								toggleAlert(true, {
									heading: 'Delete Item?',
									message: 'Click Proceed to delete item',
								});
							}}
						>
							Delete
						</Button>
						<AlertModal
							handleConfirm={() => {
								handleDelete();
								toggleAlert(false);
							}}
						/>
					</>
				)}
			</div>
		</div>
	);
};

ViewPageHeader.defaultProps = {
	showDelete: true,
	showEdit: true,
	handleDelete: () => { },
};

const mapStateToProps = (state) => {
	const { userPermissions } = state.navigation;
	return {
		userPermissions,
	};
};

const mapDispatchToProps = {
	toggleAlert: modalActions.toggleAlert,
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewPageHeader);
